/* ==========================================================================
   CSO mobile UX pass (15 Oct 2026)  —  assets/cso-mobile-ux.js
   Progressive enhancement only. Never writes to the product form, never
   changes an option's value by itself; everything it adds is derived from
   the Product Customizer <select>s that remain the source of truth.

   1. Echoes the chosen value into each option card's label ("SIZE  M") and
      marks long option buttons so the CSS can give them a full row.
   2. Adds a "Find my size" link beside the Size label → /pages/sizing-calculator.
   3. Writes a "Class 2 · Beige · M" summary into the sticky mobile bar
      (snippets/cso-mobile-bar.liquid) so a shopper can see what they've
      chosen before they tap Add to cart.
   4. On phones, replaces the collection page Sort-by <select> with chips.
      The select stays in the form (hidden); a chip sets its value and fires
      the same bubbling 'input' event Dawn's facets.js listens for.
   5. On phones, the "Size chart" <details> block (snippets/cso-size-chart.liquid)
      opens as a bottom sheet with a sticky title bar, close button and
      backdrop; closing it just sets details.open = false, so the block's own
      ankle/calf finder and style switching keep working unchanged.

   Kill switch: shop metafield cro.mobile_ux = "off" (see layout/theme.liquid).
   ========================================================================== */
(function () {
  'use strict';
  if (window.csoMobileUxInit) return;
  window.csoMobileUxInit = true;

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var SIZE_LABEL = /^\s*size\b/i;
  var SKIP_LABEL = /quantity|reminder|delivery/i;

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  // Only touch the DOM when the value really changed, so our own writes never
  // re-trigger the MutationObserver below.
  function setText(el, v) { if (el.textContent !== v) el.textContent = v; }

  // Shortens an option's visible text the same way pdp-option-pickers.js does
  // for its buttons: drop a trailing "(+$x.xx)" surcharge, a trailing
  // parenthetical detail ("Class 2 (CCL 2: 20 - 30 mmHg)" -> "Class 2") and a
  // " - note" — but never split on a dash that sits inside parentheses.
  function shortValue(select) {
    var opt = select.options[select.selectedIndex];
    if (!opt || !opt.value) return '';
    var t = opt.text.replace(/\s+/g, ' ').trim();
    t = t.replace(/\s*\(\s*\+?\$[\d.,]+\s*\)\s*$/, '').trim();
    t = t.replace(/\s*\([^()]*\)\s*$/, '').trim() || t;
    var depth = 0;
    for (var i = 0; i < t.length - 2; i++) {
      var ch = t[i];
      if (ch === '(') depth++;
      else if (ch === ')') depth--;
      else if (depth === 0 && ch === ' ' && t[i + 1] === '-' && t[i + 2] === ' ') { t = t.slice(0, i).trim(); break; }
    }
    return t;
  }

  function cardLabel(card) {
    return card.querySelector('label, .option-label') || card.firstElementChild;
  }

  function labelName(card) {
    var l = cardLabel(card);
    if (!l) return '';
    var clone = l.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('.cso-opt-val, .cso-find-size'), function (n) { n.remove(); });
    return text(clone).replace(/\s*\*\s*$/, '');
  }

  /* ---- 1 + 2: option cards ------------------------------------------------ */
  function enhanceCard(card) {
    var select = card.querySelector('select');
    var label = cardLabel(card);
    if (!select || !label) return;
    var name = labelName(card);
    if (SKIP_LABEL.test(name)) return;

    var val = card.querySelector('.cso-opt-val');
    if (!val) {
      val = document.createElement('span');
      val.className = 'cso-opt-val';
      label.appendChild(val);
      select.addEventListener('change', function () { setText(val, shortValue(select)); });
    }
    setText(val, shortValue(select));

    if (SIZE_LABEL.test(name) && !card.querySelector('.cso-find-size')) {
      var a = document.createElement('a');
      a.className = 'cso-find-size';
      a.href = '/pages/sizing-calculator';
      a.textContent = 'Find my size';
      a.setAttribute('aria-label', 'Find my size with the sizing calculator');
      label.appendChild(a);
    }

    Array.prototype.forEach.call(card.querySelectorAll('.pdp-seg-btn'), function (btn) {
      if (text(btn).length > 22) btn.classList.add('cso-seg-wide');
    });
  }

  function enhanceCards(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.product-customizer-option'), enhanceCard);
  }

  /* ---- 3: sticky bar summary ---------------------------------------------- */
  function summary() {
    var parts = [];
    Array.prototype.forEach.call(document.querySelectorAll('product-info .product-customizer-option'), function (card) {
      var select = card.querySelector('select');
      if (!select || SKIP_LABEL.test(labelName(card))) return;
      var v = shortValue(select);
      if (v) parts.push(v);
    });
    return parts.join(' · ');
  }

  function enhanceBar() {
    var bar = document.querySelector('[data-cso-mb]');
    if (!bar || bar.querySelector('.cso-mb__sum')) return;
    var priceBox = bar.querySelector('[data-cso-mb-price]') || bar;
    var sum = document.createElement('div');
    sum.className = 'cso-mb__sum';
    sum.setAttribute('aria-live', 'polite');
    priceBox.appendChild(sum);
    var update = function () { setText(sum, summary()); };
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('product-info select')) update();
    });
    update();
  }

  /* ---- 4: sort chips on phones -------------------------------------------- */
  function enhanceSort(select) {
    if (select.dataset.csoSort) return;
    var wrap = select.closest('.mobile-facets__sort') || select.closest('.facets__sort') || select.parentElement;
    if (!wrap) return;
    select.dataset.csoSort = '1';
    var chips = document.createElement('div');
    chips.className = 'cso-sort-chips';
    chips.setAttribute('role', 'group');
    chips.setAttribute('aria-label', 'Sort by');
    var buttons = [];
    Array.prototype.forEach.call(select.options, function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cso-sort-chip';
      b.dataset.value = opt.value;
      b.textContent = opt.text.trim();
      b.addEventListener('click', function () {
        if (select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      chips.appendChild(b);
      buttons.push(b);
    });
    function sync() {
      buttons.forEach(function (b) {
        var on = b.dataset.value === select.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    sync();
    select.addEventListener('change', sync);
    wrap.classList.add('cso-sort-enhanced');
    wrap.appendChild(chips);
  }

  function enhanceSorts() {
    if (!MOBILE.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.mobile-facets__sort select[name="sort_by"]'), enhanceSort);
  }

  /* ---- 5: size chart as a bottom sheet on phones ---------------------------- */
  function enhanceSizeChart(details) {
    if (details.dataset.csoSheet) return;
    details.dataset.csoSheet = '1';
    var body = details.querySelector('.cso-sc__body');
    var summary = details.querySelector('summary');
    if (!body || !summary) return;
    var backdrop = null;

    function close() { details.open = false; }
    function onToggle() {
      var sheet = MOBILE.matches && details.open;
      details.classList.toggle('cso-sc--sheet', sheet);
      document.body.classList.toggle('cso-sheet-open', sheet);
      if (sheet) {
        if (!body.querySelector('.cso-sc__sheet-head')) {
          var head = document.createElement('div');
          head.className = 'cso-sc__sheet-head';
          var title = document.createElement('span');
          title.textContent = 'Size chart';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cso-sc__close';
          btn.setAttribute('aria-label', 'Close size chart');
          btn.innerHTML = '&times;';
          btn.addEventListener('click', close);
          head.appendChild(title);
          head.appendChild(btn);
          body.insertBefore(head, body.firstChild);
        }
        if (!backdrop) {
          backdrop = document.createElement('div');
          backdrop.className = 'cso-sc__backdrop';
          backdrop.addEventListener('click', close);
        }
        details.insertBefore(backdrop, body);
        body.scrollTop = 0;
      } else if (backdrop && backdrop.parentNode) {
        backdrop.parentNode.removeChild(backdrop);
      }
    }
    details.addEventListener('toggle', onToggle);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && details.open && MOBILE.matches) close(); });
    MOBILE.addEventListener('change', onToggle);
    onToggle();
  }

  function enhanceSizeCharts() {
    Array.prototype.forEach.call(document.querySelectorAll('details.cso-sc'), enhanceSizeChart);
  }

  /* ---- boot + re-run when the app or facets re-render --------------------- */
  var pending = null;
  function run() {
    pending = null;
    enhanceCards(document);
    enhanceBar();
    enhanceSorts();
    enhanceSizeCharts();
  }
  function schedule() {
    if (pending) return;
    pending = setTimeout(run, 120);
  }

  function boot() {
    run();
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    MOBILE.addEventListener('change', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
